module.exports = __webpack_public_path__ + "img/grp-part-8-option-1.11003fbe.png";